import { render, staticRenderFns } from "./ScorePersionalComponent.vue?vue&type=template&id=72ba7676"
import script from "./ScorePersionalComponent.vue?vue&type=script&lang=js"
export * from "./ScorePersionalComponent.vue?vue&type=script&lang=js"
import style0 from "./ScorePersionalComponent.vue?vue&type=style&index=0&id=72ba7676&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports